import {cn} from 'cn';
import {FLOW_VALUE_WIDTH_CLASS} from '../format-money';

const headerClass = cn(FLOW_VALUE_WIDTH_CLASS, 'text-xs text-muted-foreground');

type FlowColumnsProps = {
	showPerUnit?: boolean;
};

export function FlowColumns({showPerUnit = true}: FlowColumnsProps) {
	return (
		<div className="flex items-baseline gap-3 pb-1">
			<div className="min-w-0 flex-1"/>
			{showPerUnit ? <span className={headerClass}>на 1 шт</span> : null}
			<span className={headerClass}>{showPerUnit ? 'итого' : 'сумма'}</span>
		</div>
	);
}
